import i18n from 'i18n/config'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getOpenModal } from 'redux/reducers/header'
import { getChangeLanguageLinkLang } from 'utils/getChangeLanguageLinkLang'
import { MobileNavOption } from '../MobileNavOption/MobileNavOption'
import { MobileNavSubList } from '../MobileNavSubList/MobileNavSubList'
import events, { Event } from 'pubsub/events'
import { MobileResourceNavItem } from 'models/Navigation'
import { getUserLoggedInState } from 'redux/reducers/users'
import { Button } from '@cmsgov/ds-medicare-gov'
import { createAndEmitLogoutEvent } from 'utils/logoutEvents/create-and-emit-logout-event'
import callEventHook from 'utils/callEventHook'
import { Categories } from 'constants/analytics'

interface PrimaryNavProps {
  navLists: MobileResourceNavItem[][];
  languageToggleLink: string;
  onNavOptionClick: (arg: any) => void;
  loginUrl: string;
  logoutUrl: string;
  disableLogin: boolean;
  handleCloseButtonClick: () => void;
  enableMessageCenter: boolean;
}

export const PrimaryNav: React.FC<PrimaryNavProps> = ({ handleCloseButtonClick, disableLogin, navLists, languageToggleLink, onNavOptionClick, loginUrl, logoutUrl, enableMessageCenter }) => {
  const { t } = useTranslation('common')
  const isLoggedIn = useSelector(getUserLoggedInState)
  const currentOpenModal = useSelector(getOpenModal)

  return (
    <>
      {
        navLists.map((navList, index) => {
          const bottomBorder = index < (navLists.length - 1)
          return (
            <MobileNavSubList
              currentOpenModal={currentOpenModal}
              handleCloseButtonClick={handleCloseButtonClick}
              navList={navList}
              onNavOptionClick={onNavOptionClick}
              key={index}
              bottomBorder={bottomBorder}
              enableMessageCenter={enableMessageCenter}
            />
          )
        })
      }

      <div>
        <MobileNavOption
          href={languageToggleLink}
          label={t('changeLanguage')}
          lang={getChangeLanguageLinkLang(i18n.language)}
          noCaret
          onClick={() => {
            const options: Event = {
              authenticated: isLoggedIn,
              text: t('changeLanguage'),
              targetLocation: languageToggleLink,
              category: Categories.LanguageSelection,
              activity: 'Link Click',
              url: window.location.href,
              language: i18n.language,
              title: document.title,
              sendToTealium: true,
              sendToCoreAPI: true,
              isMessageCenter: false
            }

            events.publish(options)
          }}
        />
      </div>

      {!disableLogin && (
        <div className='ch-u-p--20px'>
          {isLoggedIn
            ? (
              <Button
                className='ch-c-button ch-u-border-box ch-u-width--full'
                href={logoutUrl}
                onClick={async (event: any) => {
                  event.preventDefault()

                  const options: Event = {
                    authenticated: true,
                    text: t('Log out'),
                    targetLocation: logoutUrl,
                    category: Categories.PersonalNav,
                    activity: 'Button Click',
                    url: window.location.href,
                    language: i18n.language,
                    title: document.title,
                    sendToTealium: true,
                    sendToCoreAPI: true,
                    isMessageCenter: false
                  }
                  events.publish(options)
                  createAndEmitLogoutEvent()
                  await callEventHook('onLogout')

                  window.location.href = logoutUrl
                }}
              >
                {t('Log out')}
              </Button>
              )
            : (
              <Button
                className='ch-c-button ch-u-border-box ch-c-button--primary ch-u-width--full ch-u-color--white'
                href={loginUrl}
                onClick={() => {
                  const options: Event = {
                    authenticated: false,
                    text: t('Log in'),
                    targetLocation: loginUrl,
                    category: Categories.PersonalNav,
                    activity: 'Button Click',
                    url: window.location.href,
                    language: i18n.language,
                    title: document.title,
                    sendToTealium: true,
                    sendToCoreAPI: true,
                    isMessageCenter: false
                  }
                  events.publish(options)
                }}
              >
                {t('Log in')}
              </Button>
              )}
        </div>
      )}
    </>
  )
}
